import { createPortal } from 'react-dom';

// Renders children directly into document.body, escaping any ancestor that creates a CSS
// containing block (transform/filter/perspective/backdrop-filter/contain/will-change). App.js
// wraps every page in a Framer Motion <motion.div> that writes an inline `transform` — without
// this portal, any `position: fixed` modal nested in a page resolves `inset-0` against that
// div's box (which sits below the sticky header and right of the sidebar) instead of the real
// viewport, so the header/sidebar never get dimmed by the backdrop.
//
// Stacking scale for anything rendered through this portal (or otherwise fixed to the
// viewport) — pick a tier here rather than a new ad-hoc z-index:
//   20  sticky app header             (App.js)
//   30  fixed left sidebar            (Sidebar.jsx)
//   40  slide-over side panels        (EmployeeDetailPanel, etc.)
//   50  floating chat widget          (Chatbot.jsx)
//   100 modal / dialog                (default tier for Portal contents)
//   110 a modal opened from within another modal (e.g. LeaveScheduleEditModal)
export function Portal({ children }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
